import { TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { maxReportNameLength } from 'shared/constants';

import { useSectionReportName } from './SectionReportName.hooks';
import { messages } from './SectionReportName.messages';
import { SectionReportNameProps } from './SectionReportName.types';

export const SectionReportName = memo<SectionReportNameProps>((props) => {
    const { reportConfig, onReportConfigChange, isErrorsDisplayed } = props;

    const { reportName, handleChangeReportName } = useSectionReportName(reportConfig, onReportConfigChange);

    return (
        <TextField
            size='large'
            initFocus
            clearable={false}
            value={reportName}
            onChange={handleChangeReportName}
            invalid={!reportConfig.name.trim() && isErrorsDisplayed}
            label={messages.label}
            placeholder={messages.placeholder}
            required
            maxLength={maxReportNameLength}
        />
    );
});

SectionReportName.displayName = 'SectionReportName';
